import React from "react";
import Autosuggest from "react-autosuggest";
import "./Form.css";
import "./ChallanForm.css";
import "./AutoSuggest.css";
import "./popup.css";

const FormColumn = (props) => {
  const getDropdownItems = (info) => {
    if (
      process.env.REACT_APP_CLIENT === "bgtc" &&
      info.name === "pay_type" &&
      props.myFormObj.pageState.billing_party
    ) {
      return info.dropdown_items.filter((item) => item.value === "4");
    }
    return info.dropdown_items;
  };

  return (
    <>
      {props.groupInfo[props.groupName].map((info) => {
        const shouldShowVerifyButton =
          (props.formName === "AccountMaster" && info.name === "gst") ||
          (props.formName === "Bilty" &&
            ["consignor_gst", "consignee_gst"].includes(info.name));

        if (info["type"] === "dropdown") {
          return (
            <div className={info["className"]} key={info["name"]}>
              {props.checkVisibilityCondition(info) && (
                <label className={info["labelClassName"]}>
                  {info["label"]}
                </label>
              )}

              {props.checkVisibilityCondition(info) && (
                <select
                  className={info["inputClassName"]}
                  onChange={(e) => {
                    props.myFormObj.handleChangeForSelect(e, info["name"]);
                  }}
                  disabled={props.checkDisabledCondition(info)}
                  value={props.myFormObj.pageState[info["name"]]}
                  ref={(a) =>
                    props.myFormObj.storeInputReferenceForSelect(
                      a,
                      info["name"],
                    )
                  }
                  onKeyPress={(a) =>
                    props.myFormObj.onKeyPressForKeyNav(a, info)
                  }
                >
                  {getDropdownItems(info).map((item) => (
                    <option value={item.value} key={item.label}>
                      {item.label}
                    </option>
                  ))}
                </select>
              )}

              {props.myFormObj.internalValidationErrors[info["name"]] && (
                <p>{props.myFormObj.internalValidationErrors[info["name"]]}</p>
              )}
            </div>
          );
        }

        if (info["type"] === "date") {
          return (
            <div className={info["className"]} key={info["name"]}>
              <label className={info["labelClassName"]}>{info["label"]}</label>

              <input
                className={info["inputClassName"]}
                type="date"
                name={info["name"]}
                onChange={(e) => {
                  props.myFormObj.handleChange(e);
                }}
                disabled={props.checkDisabledCondition(info)}
                value={props.myFormObj.pageState[info["name"]]}
                ref={(a) =>
                  props.myFormObj.storeInputReferenceForSelect(a, info["name"])
                }
                onKeyPress={(a) =>
                  props.myFormObj.onKeyPressForKeyNav(
                    a,
                    info,
                    props.myFormObj.pageState,
                  )
                }
              />

              {props.myFormObj.internalValidationErrors[info["name"]] && (
                <p>{props.myFormObj.internalValidationErrors[info["name"]]}</p>
              )}
            </div>
          );
        }

        return (
          <div key={info["name"]}>
            <div className={info["className"]}>
              {props.checkVisibilityCondition(info) && (
                <label className={info["labelClassName"]}>
                  {info["label"]}
                </label>
              )}

              {props.checkVisibilityCondition(info) && (
                <>
                  <Autosuggest
                    id={info["name"]}
                    suggestions={props.myFormObj.suggestions || []}
                    onSuggestionsFetchRequested={(a) => {
                      if (info.apiConfigKey) {
                        props.myFormObj.onSuggestionsFetchRequestedDebounced(
                          a,
                          (b) =>
                            props.myFormObj.suggestionFetchApi(
                              info,
                              b,
                              props.getAdditionalInfoForSuggestionFetch(info),
                            ),
                        );
                      }
                    }}
                    onSuggestionsClearRequested={() =>
                      props.myFormObj.onSuggestionsClearRequested(info)
                    }
                    getSuggestionValue={(s) => s[info.suggestionKeyword]}
                    onSuggestionSelected={(a, b) => {
                      props.myFormObj.getSuggestionValue(
                        b.suggestion,
                        info,
                        props.myFormObj.performSuggestions,
                        props.myFormObj.updatePageStateForGetSuggestion,
                      );
                    }}
                    renderSuggestion={(a) =>
                      props.myFormObj.renderSuggestion(a, info)
                    }
                    highlightFirstSuggestion
                    shouldRenderSuggestions={(value) => value.trim().length > 0}
                    ref={(a) =>
                      props.myFormObj.storeInputReference(
                        a,
                        false,
                        undefined,
                        info["name"]
                      )
                    }
                    inputProps={{
                      placeholder: info["placeholder"],
                      value: String(
                        props.myFormObj.pageState[info["name"]] || "",
                      ),
                      onChange: (a, b) => {
                        props.myFormObj.onChangeAutoSuggest(a, b, info);
                      },
                      onBlur: () => props.myFormObj.onblurValidator(info),
                      onKeyPress: (a) =>
                        props.myFormObj.onKeyPressForKeyNav(
                          a,
                          info,
                          props.myFormObj.pageState,
                        ),
                      disabled: props.checkDisabledCondition(info),
                    }}
                  />

                  {shouldShowVerifyButton && (
                    <button
                      type="button"
                      onClick={() => props.handleVerifyGST(info.name)}
                      disabled={
                        typeof props.isVerifying === "boolean"
                          ? props.isVerifying
                          : props.isVerifying?.[info.name]
                      }
                      style={{
                        marginLeft: "8px",
                        padding: "5px 10px",
                        marginBottom: "10px",
                        background: "#1e293b",
                        color: "#fff",
                        borderRadius: "4px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {
                        (typeof props.isVerifying === "boolean"
                          ? props.isVerifying
                          : props.isVerifying?.[info.name])
                          ? "Verifying..."
                          : "Verify"
                      }
                    </button>
                  )}

                  {shouldShowVerifyButton &&
                    !(
                      props.formName === "Bilty" &&
                      process.env.REACT_APP_CLIENT === "bvtc"
                    ) && (
                      <span className="count-icon-wrapper">
                        <span className="count-icon">i</span>
                        <span className="count-icon-tooltip">
                          {props.gstApiCount === null ||
                          props.gstApiCount === undefined
                            ? "GST API count unavailable"
                            : `GST API called: ${props.gstApiCount}`}
                        </span>
                      </span>
                    )}
                </>
              )}

              {shouldShowVerifyButton &&
                (typeof props.gstError === "string"
                  ? props.gstError
                  : props.gstError?.[info.name]) && (
                  <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                    {typeof props.gstError === "string"
                      ? props.gstError
                      : props.gstError?.[info.name]}
                  </p>
              )}

              {props.myFormObj.internalValidationErrors[info["name"]] && (
                <p>{props.myFormObj.internalValidationErrors[info["name"]]}</p>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FormColumn;
